<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/notros.png">
    
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
    
  }
}
</script>
